import { FC } from "react";
import LegalNav from "./LegalNav";
import LegalDocumentDates from "./LegalDocumentDates";

type LegalDocumentProps = {
  /** Page heading, rendered above the cross-link nav and the dates. */
  title: string;
  /** HTML rendered from content/legal Markdown in getServerSideProps. */
  html: string;
  /** Anchor for the page wrapper, kept from the previous JSX components. */
  sectionId: string;
};

const LegalDocument: FC<LegalDocumentProps> = ({ title, html, sectionId }) => {
  return (
    <section className="bg-white py-5" id={sectionId}>
      <div className="container px-5">
        <div className="row gx-5">
          <div className="col-lg-6">
            <div className="text-black">
              <h1 className="display-5 mb-2 pb-6 text-center text-3xl font-bold">
                {title}
              </h1>
              <LegalNav />
              <LegalDocumentDates />
              {/* Content is repo-authored Markdown, rendered by our own
                  pipeline; there is no user input in this HTML. */}
              <div dangerouslySetInnerHTML={{ __html: html }} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LegalDocument;
